import type { ShipmentOriginatorsResponse } from './api';

export const normalizeShipmentOriginators = (list: ShipmentOriginatorsResponse): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.shipmentOriginator,
    value: row.shipmentOriginatorID,
  }));
};
